import { render, staticRenderFns } from "./DialogAlert.vue?vue&type=template&id=4535b342&scoped=true"
import script from "./DialogAlert.vue?vue&type=script&lang=js"
export * from "./DialogAlert.vue?vue&type=script&lang=js"
import style0 from "./DialogAlert.vue?vue&type=style&index=0&id=4535b342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535b342",
  null
  
)

export default component.exports